import {defineMessages} from 'react-intl';

export default defineMessages({
  tip: {
    id: 'toolbar_title_tip',
    defaultMessage: 'Tip'
  },
  warning: {
    id: 'toolbar_title_warning',
    defaultMessage: 'Warning'
  },
  custom: {
    id: 'toolbar_title_custom',
    defaultMessage: 'Alternative'
  },
  fix: {
    id: 'toolbar_title_fix',
    defaultMessage: 'Fix'
  }
});
